import * as React from 'react';
import Dropzone from 'react-dropzone';
import * as FontAwesome from 'react-fontawesome';
import { Button, Label } from 'reactstrap';
import './imageDropZone.css';
import { toastr } from 'react-redux-toastr';
import { BeatLoader } from 'react-spinners';

export interface IImageDropZoneState {
  clicked: boolean;
  thumbnail: string | undefined;
}
export interface IImageDropZoneProps {
  onChange?: (base64: string, imageName: string) => void
  loading?: boolean;
  status?: 'UPLOADING' | 'SUCCESS' | 'FAILED';
  thumbnail?: string;
  labelText?: string;
  className?: string;
  imageName?: string;
  onClearSearch?: () => void;
}

class ImageDropZone extends React.Component<IImageDropZoneProps, IImageDropZoneState> {
  public static getDerivedStateFromProps(props, state) {
    if (props.thumbnail !== undefined) {
      return { ...state, thumbnail: props.thumbnail };
    }
    return state;
  }
  constructor(props: any) {
    super(props);
    this.state = {
      thumbnail: undefined,
      clicked: false
    }
  }
  public handleDropAccepted = async (files) => {
    const file = files[0];
    this.setState({ thumbnail: file.preview })
    const base64 = await this.readFile(file)
    if (this.props.onChange) {
      this.props.onChange(base64, file.name);
    }
  }
  public handleDropRejected = async () => {
    toastr.error('File type not supported', 'Please select an image with jpg or png extension')
  }
  public readFile(file): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (result) => this.onLoadFile(result, resolve)
    });
  }
  public onLoadFile(result, resolve) {
    const base64 = result.target && result.target.result || ''
    resolve(base64);
  }
  public onRemoveImageSelected = (e) => {
    e.stopPropagation();
    if (this.props.onClearSearch) {
      this.props.onClearSearch();
    }
  }
  public render() {
    const { thumbnail } = this.state;
    const { status, labelText, className, imageName } = this.props;
    const failed = status === "FAILED";
    const success = status === "SUCCESS";
    const uploading = status === "UPLOADING";
    return (
      <div className={`image-dropzone-frame ${failed ? "uploadFailed" : ""}${className}`}>
        <Dropzone disabled={this.props.loading} className="drop-zone-fluid" activeClassName="active" multiple={false} accept="image/jpeg, image/png"
          onDropAccepted={this.handleDropAccepted} onDropRejected={this.handleDropRejected} >
          {labelText && <Label className="input-label subFont">{labelText}</Label>}
          {imageName && <div className="remove-image-container">
            <Button disabled={this.props.loading} className="btn btn-light upload-button remove-button" onClick={(e) => this.onRemoveImageSelected(e)} >
              <FontAwesome name='times-circle' />
            </Button>
          </div>}
          <div>
            <span className="icon-mugshot">
              {thumbnail && <img src={thumbnail} />}
              <BeatLoader size={15} color={'#db8733'} loading={uploading} />
            </span>
            <div className="status">
              {failed && <i className="fa fa-exclamation-triangle failed" aria-hidden="true" />}
              {success && <i className="fa fa-check-circle success" aria-hidden="true" />}
            </div>
          </div>
          <div className="ctrl-container">
            <div className="ctrl-section">
              {
                !this.props.loading &&
                <Button disabled={this.props.loading} id="selectFile" className="btn btn-light upload-button" onClick={() => this.setState({ clicked: true })} >
                  <FontAwesome name='plus' />
                </Button>
              }
            </div>
          </div>
        </Dropzone>
      </div>
    )
  }
}

export default ImageDropZone;


// WEBPACK FOOTER //
// ./src/share/components/ImageDropZone/ImageDropZone.tsx